<template>
<div>
    <!-- modal -->
    <b-modal id="plantVarietyFormModal" centered size="xl" no-close-on-backdrop ref="plantVarietyFormModal" :title="$t('plantVariety.info')" hide-footer @close="clear()">
        <agent-note-form ref="agentNoteFormModal"></agent-note-form>
        <reminder-form ref="reminderFormModal"></reminder-form>
        <client-form ref="clientFormModal"></client-form>
        <owner-form ref="ownerFormModal"></owner-form>
        <client-invoice-report-list-call-form ref="clientInvoiceReportListCallForm"></client-invoice-report-list-call-form>
        <mail-send-form ref="mailSendForm"></mail-send-form>
        <b-card>
            <div class="custom-search d-flex justify-content-end mb-1">
                <b-row>
                    <b-col>
                        <b-button variant="outline-primary" right size="sm" @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                        <b-dropdown v-if="id > 0" class="ml-05" right style=" height: 2.1em; " size="sm" :text="$t('others.invoices')" variant="outline-primary">
                            <b-dropdown-item @click="getClientInvoiceReport(4)">{{$t('others.invoices_to_be_paid_for_this_job')}}: {{invoicesToBePaidForThisJob}}</b-dropdown-item>
                            <b-dropdown-item @click="getClientInvoiceReport(1)">{{$t('others.all_invoices_related_to_this_job')}}: {{ allInvoicesRelatedToThisJob }}</b-dropdown-item>
                            <b-dropdown-item @click="getClientInvoiceReport(2)">{{$t('others.invoices_to_be_paid')}}: {{ invoicesToBePaid }}</b-dropdown-item>
                            <b-dropdown-item @click="getClientInvoiceReport(3)">{{$t('others.all_invoices')}}: {{ allInvoices }}</b-dropdown-item>
                        </b-dropdown>
                        <b-dropdown style=" height: 2em;" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper ml-05" size="sm">
                            <template #button-content>
                                <feather-icon icon="SendIcon" size="10" class="align-middle" />
                            </template>
                            <div class="dropdown-scroll">
                                <b-dropdown-item @click="preparePlantVarietyMail(mailTemplate.id, mailTemplate.explanation)" v-for="mailTemplate in mailTemplateList" :key="mailTemplate.id">
                                    <span>{{mailTemplate.explanation}}</span>
                                </b-dropdown-item>
                            </div>
                        </b-dropdown>
                        <b-button variant="outline-primary" class="ml-05" size="sm" v-b-tooltip.html :title="$t('others.reminder')" @click="getReminderInfo()">
                            <feather-icon icon="BellIcon" size="10" class="align-middle" />
                        </b-button>
                    </b-col>
                </b-row>
            </div>
            <validation-observer ref="simpleRules">
                <b-row>
                    <b-col class="col-md-3 mt-1">
                        <b-form>
                            <label for="plantVariety-record-no-input">{{ $t('plantVariety.record_no') }}</label>
                            <b-form-group>
                                <b-form-input id="plantVariety-record-no-input" v-model="recordNo" size="sm" disabled />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <b-form>
                            <label for="plantVariety-variety-name-input">{{ $t('plantVariety.variety_name') }}</label>
                            <b-form-group>
                                <b-form-input id="plantVariety-variety-name-input" v-model="varietyName" maxlength="250" size="sm" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <b-form>
                            <label for="plantVariety-application-no-input">{{ $t('plantVariety.application_no') }}</label>
                            <b-form-group>
                                <b-form-input id="plantVariety-application-no-input" v-model="applicationNo" maxlength="12" size="sm" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <b-form>
                            <label for="plantVariety-owner-reference-no-input">{{ $t('plantVariety.owner_reference_no') }}</label>
                            <b-form-group>
                                <b-form-input id="plantVariety-owner-reference-no-input" v-model="ownerReferenceNo" maxlength="20" size="sm" />
                            </b-form-group>
                        </b-form>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col class="col-md-3 mt-1">
                        <label for="plantVariety-application-date-input">{{ $t('plantVariety.application_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="applicationDate"></CustomDatePicker>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <label for="plantVariety-last-application-date-input">{{ $t('plantVariety.last_application_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="lastApplicationDate"></CustomDatePicker>
                    </b-col>

                    <b-col class="col-md-3 mt-1">
                        <label for="plantVariety-deadline-date-input">{{ $t('plantVariety.deadline_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="deadlineDate"></CustomDatePicker>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <label for="plantVariety-instruction-date-input">{{ $t('plantVariety.instruction_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="instructionDate"></CustomDatePicker>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-3 mt-1">
                        <b-form>
                            <label for="plantVariety-registry-no-input">{{ $t('plantVariety.registry_no') }}</label>
                            <b-form-group>
                                <b-form-input id="plantVariety-registry-no-input" v-model="registryNo" maxlength="20" size="sm" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <label for="plantVariety-registry-date-input">{{ $t('plantVariety.registry_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="registryDate"></CustomDatePicker>
                    </b-col>
                    <b-col class="col-md-3 mt-1">
                        <label for="plantVariety-registry-fee-payment-date-input">{{ $t('plantVariety.registry_fee_payment_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="registryFeePaymentDate"></CustomDatePicker>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <b-form>
                            <label for="plantVariety-agent-ref-code-input">{{ $t('plantVariety.agent_reference_no') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="plantVariety-agent-ref-code-input" v-model="agentReferenceNo" maxlength="100" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>

                <b-row v-if="hiddenControl == false">
                    <b-col class="col-lg-12 mt-1">
                        <b-form-group>
                            <label for="plantVariety-agent-input"> {{ $t('plantVariety.agent') }} </label>
                            <b-input-group class="d-flex align-items-center">
                                <b-form-group label-for="plantVariety-agent-input" class="flex-grow-1 mb-0">
                                    <v-select id="plantVariety-agent-input" v-model="plantVarietyAgentSelect" :options="plantVarietyAgentOption" @input="setClientId" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onSearch"></v-select>
                                </b-form-group>
                                <b-input-group-append>
                                    <b-dropdown style="width: 3em; height: 2.5em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                        <template #button-content>
                                            <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                                        </template>
                                        <b-dropdown-item @click="getClientInfo(0)">
                                            <span>{{ this.$t('others.add_client') }}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getAgentNoteInfo(plantVarietyAgentSelect.clientAccountingId)">
                                            <span>{{ this.$t('others.show_note') }}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getClientInfo(plantVarietyAgentSelect.clientId)">
                                            <span>{{ this.$t('others.show_agent') }}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getCopyContentInfo(plantVarietyAgentSelect)">
                                            <span>{{this.$t('others.copy_content')}}</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-else-if="hiddenControl == true">
                    <b-col class="col-lg-12 mt-1">
                        <b-form-group>
                            <label for="plantVariety-agent-input"> {{ $t('plantVariety.agent') }} </label>
                            <b-input-group class="d-flex align-items-center">
                                <b-form-group label-for="plantVariety-agent-input" class="flex-grow-1 mb-0">
                                    <v-select id="plantVariety-agent-input" v-model="plantVarietyAgentSelect" :options="plantVarietyAgentOption" @input="setClientId" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onSearch"></v-select>
                                </b-form-group>
                                <b-input-group-append>
                                    <b-dropdown style="width: 3em; height: 2.5em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                        <template #button-content>
                                            <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                                        </template>
                                        <b-dropdown-item @click="getClientInfo(0)">
                                            <span>{{ this.$t('others.add_client') }}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getClientInfo(plantVarietyAgentSelect.clientId)">
                                            <span>{{ this.$t('others.show_agent') }}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getCopyContentInfo(plantVarietyAgentSelect)">
                                            <span>{{this.$t('others.copy_content')}}</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="plantVariety-invoice-client-accounting-input">{{ $t('plantVariety.invoice_client_accounting') }}</label>
                        <b-input-group class="d-flex align-items-center">
                            <b-form-group label-for="plantVariety-invoice-client-accounting-input" class="flex-grow-1 mb-0">
                                <v-select id="plantVariety-invoice-client-accounting-input" v-model="plantVarietyInvoiceClientSelect" :options="plantVarietyInvoiceClientOption" @input="setClientIdWithInvoiceClientCheck" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onInvoiceClientAccountingSearch"></v-select>
                            </b-form-group>
                            <b-input-group-append>
                                <b-dropdown style="width: 3em; height: 2.5em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                    <template #button-content>
                                        <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                                    </template>
                                    <b-dropdown-item @click="getClientInfo(0)">
                                        <span>{{ this.$t('others.add_client') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getAgentNoteInfo(plantVarietyInvoiceClientSelect.clientAccountingId)">
                                        <span>{{ this.$t('others.show_note') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getClientInfo(plantVarietyInvoiceClientSelect.clientId)">
                                        <span>{{ this.$t('others.show_agent') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getCopyContentInfo(plantVarietyInvoiceClientSelect)">
                                        <span>{{this.$t('others.copy_content')}}</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="plantVariety-renewal-client-input">{{ $t('plantVariety.renewal_agent') }}</label>
                        <b-input-group class="d-flex align-items-center">
                            <b-form-group label-for="plantVariety-renewal-client-input" class="flex-grow-1 mb-0">
                                <v-select id="plantVariety-renewal-client-input" v-model="plantVarietyRenewalClientSelect" :options="plantVarietyRenewalClientOption" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onRenewalClientSearch"></v-select>
                            </b-form-group>
                            <b-input-group-append>
                                <b-dropdown style="width: 3em; height: 2.5em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                    <template #button-content>
                                        <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                                    </template>
                                    <b-dropdown-item @click="getClientInfo(0)">
                                        <span>{{ this.$t('others.add_client') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getAgentNoteInfo(plantVarietyRenewalClientSelect.clientAccountingId)">
                                        <span>{{ this.$t('others.show_note') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getClientInfo(plantVarietyRenewalClientSelect.clientId)">
                                        <span>{{ this.$t('others.show_agent') }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="getCopyContentInfo(plantVarietyRenewalClientSelect)">
                                        <span>{{this.$t('others.copy_content')}}</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-card>
        <b-card :hidden="hiddenControl">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab active :title="$t('plantVariety.owner')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-owner-list :getOwnerInfo="getOwnerInfo" :getPlantVarietyList="getPlantVarietyList" :plantVarietyId="this.id"></plantVariety-owner-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('plantVariety.reformer')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-reformer-list :getPlantVarietyList="getPlantVarietyList" :plantVarietyId="this.id"></plantVariety-reformer-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('plantVariety.digital_archive')" style="width:100%;">
                            <b-card-text>
                                <documents-list :recordId="this.id" :moduleId="13"></documents-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('plantVariety.history')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-history-list :getPlantVarietyList="getPlantVarietyList" :plantVarietyId="this.id"></plantVariety-history-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('plantVariety.annuity')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-annuity-list :getPlantVarietyList="getPlantVarietyList" :plantVarietyId="this.id"></plantVariety-annuity-list>
                            </b-card-text>
                        </b-tab>
                        <!-- <b-tab :title="$t('plantVariety.responsible')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-responsible-list :plantVarietyId="this.id" :clientId="this.clientId"></plantVariety-responsible-list>
                            </b-card-text>
                        </b-tab> -->
                        <b-tab :title="$t('plantVariety.priority')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-priority-list :getPlantVarietyList="getPlantVarietyList" :plantVarietyId="this.id"></plantVariety-priority-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('plantVariety.note')" style="width:100%;">
                            <b-card-text>
                                <plantVariety-note-list :getPlantVarietyList="getPlantVarietyList" :plantVarietyId="this.id"></plantVariety-note-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title=" $t('plantVariety.job')" style="width:100%;">
                            <b-card-text>
                                <job-list :recordId="this.id" :moduleId="13" :recordNo="this.recordNo"></job-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title=" $t('plantVariety.dailywork')" style="width:100%;">
                            <b-card-text>
                                <dailywork-list :recordId="this.id" :moduleId="13" :departmentId="8"></dailywork-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        plantVarietyForm: Object,
        getPlantVarietyList: {
            type: Function
        },
    },

    data() {
        return {
            id: 0,
            clientId: 0,
            recordNo: '',
            applicationNo: '',
            applicationDate: null,
            lastApplicationDate: null,
            instructionDate: null,
            plantVarietyAgentSelect: 0,
            plantVarietyAgentOption: [],
            plantVarietyPublicationTypeSelect: 0,
            plantVarietyPublicationTypeOption: [],
            plantVarietyTypeSelect: 0,
            plantVarietyTypeOption: [],
            agentReferenceNo: '',
            hiddenControl: true,
            plantVarietyInvoiceClientSelect: 0,
            plantVarietyInvoiceClientOption: [],
            invoiceClientId: 0,
            wordTemplateList: [],
            mailTemplateList: [],
            invoicesToBePaidForThisJob: 0,
            invoicesToBePaid: 0,
            allInvoices: 0,
            allInvoicesRelatedToThisJob: 0,
            clientAccountingId: 0,
            plantVarietyRenewalClientOption: [],
            plantVarietyRenewalClientSelect: 0,
            renewalClientAccountingId: 0,
            varietyName: '',
            deadlineDate: null,
            registryNo: '',
            registryDate: null,
            ownerReferenceNo: '',
            registryFeePaymentDate: null,
        }
    },
    watch: {
        deadlineDate(newValue) {
            if (newValue == '') {
                this.deadlineDate = null
            }
        },
        instructionDate(newValue) {
            if (newValue == '') {
                this.instructionDate = null
            }
        },
        registryFeePaymentDate(newValue) {
            if (newValue == '') {
                this.registryFeePaymentDate = null
            }
        },
        applicationDate(newValue) {
            if (newValue == '') {
                this.applicationDate = null
            }
        },
    },
    methods: {

        getClientInvoiceReport(type) {
            this.$refs.clientInvoiceReportListCallForm.showInfo(type, this.clientAccountingId, 13, this.id)
        },
        async getReminderInfo() {
            this.$refs.reminderFormModal.showInfo(0, this.id, 13)
        },
        async getAgentNoteInfo(clientAccountingId) {
            this.$refs.agentNoteFormModal.getNoteListByAccountingId(clientAccountingId)
        },
        async getClientInfo(clientId) {
            this.$refs.clientFormModal.showInfo(clientId)
        },
        async getOwnerInfo(clientId) {
            this.$refs.ownerFormModal.showInfo(clientId)
        },
        setClientId(event) {
            if (event != null) {
                this.clientId = event.clientId
            } else {
                this.clientId = null;
            }
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    ClientAccountingTypeId: 1,
                    clientName: search,
                    forAgentOrInvoice: 1,
                    clientAccountingTypeId: 1,

                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.plantVarietyAgentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        onInvoiceClientAccountingSearch(invoiceClientAccountingSearch, loading) {
            if (invoiceClientAccountingSearch.length) {
                loading(true);
                this.invoiceClientAccountingSearch(loading, invoiceClientAccountingSearch, this);
            }
        },
        invoiceClientAccountingSearch(loading, invoiceClientAccountingSearch, vm) {
            if (invoiceClientAccountingSearch.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    ClientAccountingTypeId: 1,
                    clientName: invoiceClientAccountingSearch,
                    forAgentOrInvoice: 2,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.plantVarietyInvoiceClientOption = response.data.clientList
                    loading(false)
                })
            }
        },
        showInfo(id) {
            this.$refs['plantVarietyFormModal'].show()
            this.id = id
            if (this.id == 0)
                this.hiddenControl = true
            else
                this.hiddenControl = false
            const data = {
                id: this.id
            }
            const controller = {
                name: 'PlantVariety'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.wordTemplateList = response.data.wordTemplateList
                    this.mailTemplateList = response.data.mailTemplateList
                    this.recordNo = response.data.plantVariety.recordNo
                    this.agentReferenceNo = response.data.plantVariety.agentReferenceNo
                    this.varietyName = response.data.plantVariety.varietyName
                    this.applicationNo = response.data.plantVariety.applicationNo
                    this.applicationDate = response.data.plantVariety.applicationDate
                    this.lastApplicationDate = response.data.plantVariety.lastApplicationDate
                    this.deadlineDate = response.data.plantVariety.deadlineDate
                    this.instructionDate = response.data.plantVariety.instructionDate
                    this.registryNo = response.data.plantVariety.registryNo
                    this.registryDate = response.data.plantVariety.registryDate
                    this.ownerReferenceNo = response.data.plantVariety.ownerReferenceNo
                    this.registryFeePaymentDate = response.data.plantVariety.registryFeePaymentDate
                    if (response.data.plantVariety.clientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.plantVariety.clientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.plantVarietyAgentOption = clientAccountingResponse.data.clientList
                            this.plantVarietyAgentSelect = clientAccountingResponse.data.clientList[0]
                            this.clientId = clientAccountingResponse.data.clientList[0].clientId
                        })
                    } else {
                        this.plantVarietyAgentOption = []
                        this.plantVarietyAgentSelect = 0;
                    }
                    if (response.data.plantVariety.invoiceClientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.plantVariety.invoiceClientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.plantVarietyInvoiceClientOption = clientAccountingResponse.data.clientList
                            this.plantVarietyInvoiceClientSelect = clientAccountingResponse.data.clientList[0]
                        })
                    } else {
                        this.plantVarietyInvoiceClientOption = []
                        this.plantVarietyInvoiceClientSelect = 0;
                    }
                    //STOCK-1491
                    if (response.data.plantVariety.renewalClientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.plantVariety.renewalClientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.plantVarietyRenewalClientOption = clientAccountingResponse.data.clientList
                            this.plantVarietyRenewalClientSelect = clientAccountingResponse.data.clientList[0]
                        })
                    } else {
                        this.plantVarietyRenewalClientOption = []
                        this.plantVarietyRenewalClientSelect = 0;
                    }
                    //
                    if (this.id > 0) {
                        let accountingId = 0
                        if (response.data.plantVariety.clientAccountingId > 0)
                            accountingId = response.data.plantVariety.clientAccountingId
                        if (response.data.plantVariety.invoiceClientAccountingId > 0)
                            accountingId = response.data.plantVariety.invoiceClientAccountingId
                        this.clientAccountingId = accountingId
                        const invoiceData = {
                            clientAccountingId: accountingId,
                            moduleId: 13,
                            recordId: this.id,
                            recordNo: this.recordNo
                        }
                        const invoiceController = {
                            name: 'ClientAccounting',
                            actionName: 'GetInvoiceCountByClientAccountId'
                        }
                        const invoicePayload = {
                            data: invoiceData,
                            controller: invoiceController
                        }
                        this.$store.dispatch('moduleAuth/customService', invoicePayload).then((invoiceResponse) => {
                            this.invoicesToBePaid = invoiceResponse.data.invoicesToBePaidCount
                            this.allInvoices = invoiceResponse.data.allInvoiceCount
                            this.allInvoicesRelatedToThisJob = invoiceResponse.data.allInvoicesRelatedToThisJobCount
                            this.invoicesToBePaidForThisJob = invoiceResponse.data.invoicesToBePaidForThisJobCount
                        })

                    } else {
                        this.invoicesToBePaid = 0
                        this.allInvoices = 0;
                        this.allInvoicesRelatedToThisJob = 0;
                        this.invoicesToBePaidForThisJob = 0;
                    }
                } else {
                    this.$bvModal.hide('plantVarietyFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        downloadPlantVarietyWordFile(documentId, name) {
            const data = {
                moduleId: 13,
                documentId: documentId,
                plantVarietyId: this.id
            }
            const controller = {
                name: 'PlantVariety',
                actionName: 'DownloadPlantVarietyWordFile'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(name, response.data.base64, 'docx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            if (this.plantVarietyInvoiceClientSelect === null) {
                this.invoiceClientId = 0
            } else {
                this.invoiceClientId = this.plantVarietyInvoiceClientSelect.clientAccountingId
            }
            if (this.plantVarietyRenewalClientSelect === null) {
                this.renewalClientAccountingId = 0
            } else {
                this.renewalClientAccountingId = this.plantVarietyRenewalClientSelect.clientAccountingId;

            }
            const data = {
                id: this.id,
                agentReferenceNo: this.agentReferenceNo,
                clientAccountingId: this.plantVarietyAgentSelect.clientAccountingId,
                applicationDate: this.applicationDate,
                applicationNo: this.applicationNo,
                lastApplicationDate: this.lastApplicationDate,
                ownerReferenceNo: this.ownerReferenceNo,
                invoiceClientAccountingId: this.invoiceClientId,
                renewalClientAccountingId: this.renewalClientAccountingId,
                instructionDate: this.instructionDate,
                varietyName: this.varietyName,
                deadlineDate: this.deadlineDate,
                registryNo: this.registryNo,
                registryDate: this.registryDate,
                registryFeePaymentDate: this.registryFeePaymentDate,

            }

            const controller = {
                name: 'PlantVariety'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            if (this.getPlantVarietyList != null)
                                this.getPlantVarietyList()
                            this.$SaveAlert()
                            if (this.id == 0) {
                                this.id = response.data.plantVarietyId
                                this.recordNo = response.data.recordNo
                                this.hiddenControl = false
                            }
                            // this.correctApplicationNo = applicationNo
                        } else {
                            if (response.data.resultMessage == "ThereIsAPlantVarietyWithThatApplicationNo") {
                                this.$WarningAlert(this.$t('alerts.there_is_a_plantVariety_with_that_application_no'))
                            } else {
                                this.$WarningAlert(response.data.resultMessage)

                            }

                        }
                    })
                }
            })
        },
        preparePlantVarietyMail(mailTemplateId) {
            const data = {
                mailTemplateId: mailTemplateId,
                recordId: this.id,
                moduleId: 13
            }
            const controller = {
                name: 'MailTemplate',
                actionName: 'PrepareMailTemplate'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$refs.mailSendForm.showInfo(response.data, this.id)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        setClientIdWithInvoiceClientCheck(event) {
            if (event != null) {
                if (this.plantVarietyInvoiceClientSelect.forInvoice == false) {
                    this.clientId = null;
                    this.plantVarietyInvoiceClientSelect = null;
                    this.$ForInvoiceAlert()
                } else {
                    this.clientId = event.clientId
                }
            } else {
                this.clientId = null;
            }
        },
        onRenewalClientSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.renewalClientSearch(loading, search, this);
            }
        },
        renewalClientSearch(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    ClientAccountingTypeId: 1,
                    clientName: search,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.plantVarietyRenewalClientOption = response.data.clientList
                    loading(false)
                })
            }
        },
        clear() {
            this.id = 0
            this.agentReferenceNo = ''
            this.plantVarietyAgentSelect = null
            this.applicationDate = null
            this.applicationNo = ''
            this.lastApplicationDate = null
            this.ownerReferenceNo = ''
            this.invoiceClientId = null
            this.renewalClientAccountingId = null
            this.instructionDate = null
            this.varietyName = ''
            this.deadlineDate = null
            this.registryNo = ''
            this.registryDate = null
            this.registryFeePaymentDate = null
            this.recordNo = ''
            this.recordId = 0
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .dark-layout .modal .modal-content,
[dir] .dark-layout .modal .modal-body,
[dir] .dark-layout .modal .modal-footer {
    background-color: #272e3f !important;
    border-color: #3b4253;
}

[dir] body.dark-layout .b-calendar-grid.form-control .small {
    background: #161d31;
    display: none !important;
}

.b-calendar .b-calendar-grid-help {
    color: #6e6b7b !important;
    display: none;
}

[dir] .custom-height {
    height: 30px;
}

.b-tab {
    max-width: 70em;
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}

.dropdown-scroll {
    max-height: 200px;
    /* Dropdown içeriği için maksimum yükseklik */
    overflow-y: auto;
    /* Yatay kaydırma çubuğunu etkinleştir */
}

.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
